import md5 from 'md5'

//
// Widget URL creator based on amount, date, time and meal ID
//
export function useWidgetUrl(hash, mealId, amount, date, time = undefined) {
  const baseUrl = `https://app.bokabord.se/reservation/?`
  
  const query = {
    amount: amount,
    app_type: 'bokabord',
    date: date,
    from_url: 'bokabord_fat',
    hash: hash,
    is_bokabord_web: 'Y',
    mealid: mealId,
    time: time,
    hd_meal: mealId ? md5(mealId) : undefined
  }

  return `${baseUrl}${useObjectToQueryString(query)}`
}

//
// Open external widget in new tab
//
export function useOpenExternalWidget(hash, mealId, amount, date, time = undefined) {
  const url = useWidgetUrl(hash, mealId, amount, date, time)
  window.open(url, '_blank')
}

//
// Create query param as single string
//
export function useCreateWidgetQuery(hash, mealId, amount, date, time = undefined) {
  return [hash, mealId, amount, date, time].filter(i => i).join(';')
}

//
// Parse widget query param
//
export function useParseWidgetQuery(queryWidget = null) {
  const params = queryWidget?.split(';') ?? []
  return {
    hash: params[0] || undefined,
    mealid: params[1] || undefined,
    amount: params[2] || undefined,
    date: params[3] || undefined,
    time: params[4] || undefined,
  }
}

//
// Open widget in iFrame by pushing the query
//
export function useOpenWidget(hash, mealId, amount, date, time = undefined) {
  const route = useRoute()
  const router = useRouter()
  const widgetParams = useCreateWidgetQuery(hash, mealId, amount, date, time)
  router.push({ query: { ...route.query, 'widget': widgetParams }})
}

//
// Close widget by resetting the query param
//
export function useCloseWidget() {
  const route = useRoute()
  const router = useRouter()
  router.push({ query: { ...route.query, widget: undefined }})
}
